exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modules__title[data-v-2c538acf]{margin-bottom:18px;font-family:inherit;font-size:16px;font-weight:400;line-height:1.25}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2c538acf","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/catalog/card/components/tabs/modules/Modules.vue
// module id = 19eed941e7aa2cf9ccbc
// module chunks = 6